<script setup lang="ts">
import merge from 'lodash-es/merge';
import type { FolderListItemModel } from '../../../pages/cms/management/pages/_runtime/services/PagesService';
import PagesService from '../../../pages/cms/management/pages/_runtime/services/PagesService';

defineOptions({
    name: 'WidgetMenuSettings'
});

interface FormSettings
{
    settings: any;
}

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const { $log } = useLogging();
const { $t } = useLocalization();

const folders = ref<FolderListItemModel[]>([]);
const defaults = ref<any>({
    folder: null,
    fromLevel: 1,
    toLevel: 1,
    expand: 1
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

const levels = computed<Option<number>[]>(() =>
{
    return new Array(10).fill(null).map((value, index) =>
    {
        return { value: index + 1, text: (index + 1).toString() };
    });
});

async function loadFolders(): Promise<void>
{
    try
    {
        folders.value = (await PagesService.getFolders(form.value.websiteId, form.value.locale)).items.map(p => p.result);
    }
    catch (ex)
    {
        folders.value = [];
        $log.debug(ex);
    }
}

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            folder: schema.string().nullable().required($t('[[[Wybranie katalogu jest wymagane]]]'))
        })
    }));
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);

    await loadFolders();
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Katalog]]]')" :invalid-feedback="form.$errors.first('settings.folder')" :state="form.$errors.state('settings.folder')" required>
        <IdeoFormSelect v-model="form.settings.folder" name="settings.folder" :options="folders" value-field="id" text-field="name">
            <template #first>
                <option :value="null">
                    {{ $t('[[[wybierz katalog]]]') }}
                </option>
            </template>
        </IdeoFormSelect>
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Od poziomu]]]')" :invalid-feedback="form.$errors.first('settings.fromLevel')" :state="form.$errors.state('settings.fromLevel')">
        <IdeoFormSelect v-model="form.settings.fromLevel" name="settings.fromLevel" :options="levels" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Do poziomu]]]')" :invalid-feedback="form.$errors.first('settings.toLevel')" :state="form.$errors.state('settings.toLevel')">
        <IdeoFormSelect v-model="form.settings.toLevel" name="settings.toLevel" :options="levels" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Rozwiń do]]]')" :invalid-feedback="form.$errors.first('settings.expand')" :state="form.$errors.state('settings.expand')">
        <IdeoFormSelect v-model="form.settings.expand" name="settings.expand" :options="levels" />
    </IdeoFormGroup>
</template>
